import { isEmpty } from 'ramda'
import { useState, useEffect } from 'react'
import type EnvironmentIDB from 'react-relay-offline/lib/runtime/EnvironmentIDB'
import { useRelayEnvironment } from 'relay-hooks'

export const useIsRelayOfflinePendingActions = () => {
  const environment = useRelayEnvironment() as ReturnType<
    typeof EnvironmentIDB.create
  >

  const [state, setState] = useState(
    () => !isEmpty(environment.getStoreOffline().getListMutation())
  )

  useEffect(() => {
    return environment.getStoreOffline().subscribe((mutationList) => {
      setState(!isEmpty(mutationList))
    })
  }, [setState])

  return state
}
